<template lang="pug">
.crud
    modal-shipment-detail(:detail="detail" :index="index" :isAdd="true" :title="ModalShipmentDetail").modal_index
    modal-shipment-claim(:detail="detail" :index="index" :isEdit="true")
    modal-show-claim(:detail="detail" :index="index" :IsCustomer="IsCustomer")
    modal-views-claim(:detail="detail" :index="index")
    modal-shipment-detail-edit(:detail="detail" :index="index")
    modal-remision(:remision="remision" :shipment="shipment" :is-add="isModalAdd")
    .container-fluid
      vm-row.heading(vm-w="12")
        vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
            a(href="javascript:history.go(-1)")
              vm-button(icon="arrow-back-outline" radius)
            h2 &nbsp {{ getTitle() }}:
        vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
          div
            vm-button#saveRecord.vm-con-loading__container(icon="save-outline" v-if="shipments_update_permission && !$auth.check('Employee') || shipments_store_permission && !$auth.check('Employee') " :disabled="isInvalid"  @click="saveRecord") {{ $t('strings.save') }}
            vm-tooltip(:text="$t('strings.options')" delay=".5s")
              vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                vm-button(type="border" icon="more-horizotnal" color="#afbbc6")

                vm-dropdown-menu
                  vm-dropdown-item.d-flex.justify-content-between(v-if="shipment.status == '1'" @click="printReportRecord(shipment)" :disabled="!enabledEdit")
                    vm-icon(icon="printer-outline")
                    slot &nbsp;{{ $t('strings.print') }}
                  //- More options
                      vm-dropdown-item.d-flex.justify-content-between(v-if="shipment.status == '1'" @click="setActionShipment(shipment, 'send')")
                        vm-icon(icon="checkmark-circle-outline")
                        slot &nbsp;{{ $t('strings.send') }}
                      Agrega mas acciones para colecciones de datos
      vm-row(vm-w="12")
        vm-col.card(vm-sm=12)
          vm-row.form(vm-align="center" vm-type="flex" vm-w="12")
            vm-col(vm-justify="center", vm-align="center", vm-w=3)
              b-form-group
                vm-input(autofocus :placeholder='$t("shipments.remission_number_placeholder")' :danger="$v.newRecord.remission_number.$invalid && $v.newRecord.remission_number.$model" :danger-text="$t('validation.required', { attribute: $t('shipments.remission_number') })" v-model="newRecord.remission_number" :label='$t("shipments.remission_number")' type="number" required)
            vm-col(vm-justify="center", vm-align="center", vm-w=6)
              b-form-group
                vm-input(:placeholder='$t("shipments.addressee_placeholder")' :danger="$v.newRecord.addressee.$invalid && $v.newRecord.addressee.$model" :danger-text="$t('validation.required', { attribute: $t('shipments.addressee') })" v-model="newRecord.addressee" :label='$t("shipments.addressee")' required)
            vm-col(vm-justify="center", vm-align="center", vm-w=3)
              b-form-group
                vm-date-picker(:danger="$v.newRecord.shipped_date.$invalid && $v.newRecord.shipped_date.$model" :danger-text="$t('validation.required', { attribute: $t('shipments.shipped_date') })" v-model="newRecord.shipped_date" :label='$t("shipments.shipped_date")' required)
            vm-col(vm-justify="center", vm-align="center", vm-w=3)
              b-form-group
                vm-date-picker(v-model="newRecord.estimate_arrival" :label='$t("shipments.estimate_arrival")')
            vm-col(vm-justify="center", vm-align="center", vm-w=9)
              b-form-group
                vm-input(:placeholder='$t("shipments.comments_placeholder")' v-model="newRecord.comments" :label='$t("shipments.comments")')
          vm-tabs
            vm-tab(vm-label="Bill of Materials" vm-alignment="fixed")
              vm-row.heading(vm-w="12")
                vm-col(vm-type="flex" vm-justify="flex-end" vm-lg=12 vm-sm=12)
                  div
                    vm-button.separador(:disabled="!isAdd" icon="plus" @click="addRemision()" v-if="$auth.user().view_roles.findIndex(e => e === 'Customer')") {{ $t('strings.add') }}
              vm-row.heading(vm-w="12")
                vm-col(vm-type="flex" vm-justify="flex-end" vm-lg=12 vm-sm=12)
                  vm-table(max-height="350px" :data="shipment.remisions")
                    template(slot="header")
                      .d-flex.justify-content-between
                        div
                        div
                    template(slot="thead")
                      vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columnsRemisions") {{ column ? $t('gallery.' + column) : ''}}
                      vm-th
                    template(slot-scope="{data}")
                      vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                        vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columnsRemisions")
                          .details(@click="openViewer(data[indextr])")
                            slot(v-if="column != 'remision' && column != 'date' && column != 'description'") {{data[indextr][column]}}
                            slot(v-if="column == 'remision'") {{data[indextr]['remision'] === 1 ? 'Cano To JSS' : 'Cano to Client'}}
                            slot(v-if="column == 'description' && data[indextr]['description'] != 'undefined'")  {{data[indextr][column]}}
                            slot(v-if="column == 'date'")  {{data[indextr][column] | moment("DD MMMM YYYY") }}
                            slot(v-if="column == ''") {{ $t("strings.show_file") }}
                              vm-icon(icon="file-text-outline")
                        vm-dropdown(:disabled="!isAdd" vm-custom-content vm-trigger-click vm-trigger-outside-click)
                          vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")
                          vm-dropdown-menu
                            vm-dropdown-item.d-flex.justify-content-between(@click="editRemision(data[indextr])")
                              vm-icon(icon="edit-outline")
                              slot &nbsp;{{ $t('strings.edit') }}
                            vm-dropdown-item.d-flex.justify-content-between(@click="deleteRemisionConfirm(data[indextr])")
                              vm-icon(icon="trash-2-outline")
                              slot &nbsp;{{ $t('strings.delete') }}
            vm-tab(vm-label="Details" vm-alignment="fixed")
              vm-table(max-height="350px" :data="details")
                template(slot="header")
                  .d-flex.justify-content-between
                    div
                    div
                      vm-button(v-if="false" @click="submitShipmentDetails" :disabled="form.length === 0") {{ $t('strings.update') }}
                      vm-button(v-if="!isAdd" @click="addProduct(details)") add Product

                template(slot="thead")
                  vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('shipments.' + column) }}
                  vm-th(v-if="isAdd") {{ $t('shipments.add_shipped') }}
                  vm-th(v-else) {{ $t('shipments.shipment_complete_total') }}
                  vm-th
                template(slot-scope="{data}")
                  vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data" v-if="data[indextr]['fabricated_remaining'] !== data[indextr]['quantity']")
                    vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                      slot(v-if="column == 'total' || column == 'unit_price'")  {{data[indextr][column] | currency }}
                      slot(v-if="column != 'status' && column != 'total' && column != 'unit_price' && column != 'project_detail_id' && column != 'add_shipped' && column != 'category'") {{data[indextr][column]}}
                      slot(v-if="column == 'project_detail_id'") {{data[indextr]['project_detail']['category_unit']}}
                      slot(v-if="column == 'category'") {{data[indextr]['category']['type']}}
                    vm-td(v-if="isAdd")
                      dual-input(:max="data[indextr]['shipment_remaining']" :data="data[indextr]['shipment_remaining']" :item="data[indextr]" :idx="indextr" @input="setShipped" :disabledLeft="data[indextr]['shipment_complete']" :disabledRight="true" :resetVal="reset" @reset="doReset")
                    vm-td(v-if="data[indextr]['edit']")
                      vm-input(
                        :placeholder="edit"
                        :danger="edit"
                        :danger-text="edit" v-model="data[indextr]['quantity']"
                        :label='edit' type="number"  required
                        style="width: 80px; padding: 0; margin: 0;")
                        vm-col(vm-justify="center", vm-align="center", vm-w=1)
                    vm-td(v-if="!data[indextr]['edit'] && !isAdd")
                      slot {{ data[indextr]['quantity'] }}
                    vm-td(v-if="data[indextr]['edit']")
                      .icon-btn(@click="salveDetail(data, indextr)")
                        vm-icon(icon="save-outline" color="black")
                    vm-td(v-else)
                      .icon-btn(@click="noting()")
                        vm-icon(icon="save-outline" color="transparent")
                    vm-td(v-if="!isAdd && !$auth.check('Employee')")
                      .icon-btn(@click="editDetail(data, indextr)")
                        vm-icon(icon="edit-2-outline" color="black")
              vm-row(vm-type="flex" vm-justify="flex-end" vm-lg=12 vm-sm=12 v-if="isAdd")
                vm-button.btn_set(size="medium" icon="save-outline" v-if="shipments_update_permission || shipments_store_permission" :disabled="isInvalid"  @click="saveRecord") {{ $t('strings.save') }}
            vm-tab(vm-label="Claims" vm-alignment="fixed" v-if="!isAdd")
              vm-table(v-model="selected" max-height="350px" :data="claims")
                template(slot="header")
                  .d-flex.justify-content-between
                    div
                    div
                template(slot="thead")
                  vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columnsClaims") {{ $t('claims.' + column) }}
                  vm-th
                template(slot-scope="{data}")
                  vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                    vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columnsClaims")
                      div(@click="showShipmentClaim(data[indextr], indextr)")
                        slot(v-if="column != 'status' && column != 'question' && column != 'answer' && column != 'total' && column != 'project_id' && column != 'customer_id'") {{data[indextr][column]}}
                        slot(v-if="column == 'question'") {{data[indextr]['question'] | truncate }}
                        slot(v-if="column == 'answer'") {{data[indextr]['answer'] | truncate }}
                        slot(v-if="column == 'project_id'") {{data[indextr]['project_name']}}
                        slot(v-if="column == 'customer_id'") {{data[indextr]['customer_name']}}
                    vm-td
                    vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                      vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")

                      vm-dropdown-menu
                        vm-dropdown-item.d-flex.justify-content-between(@click="editShipmentClaim(data[indextr], indextr)" v-if="claims_update_permission && !customer")
                          vm-icon(icon="edit-2-outline")
                          slot &nbsp;{{ $t('strings.edit') }}
                        vm-dropdown-item.d-flex.justify-content-between(@click="claimSeen(data[indextr], indextr)" v-if="customer")
                          vm-icon(icon="eye-outline")
                          slot &nbsp;{{ $t('strings.views') }}
              vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
</template>

<script>
import moment from 'moment'
import { required } from 'vuelidate/lib/validators'
import parseVuexObject from '@/utils/parseVuexObject'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('InOrders')

export default {
  name: 'ShipmentDetail',
  components: {
    ModalShipmentDetail: () => import('@/components/in-order/ModalShipmentDetail.vue'),
    DualInput: () => import('@/components/aditionals/DualInput.vue'),
    ModalRemision: () => import('@/components/in-order/ModalRemision.vue'),
    ModalShipmentClaim: () => import('@/components/in-order/ModalShipmentClaim.vue'),
    ModalShipmentDetailEdit: () => import('@/components/in-order/ModalShipmentDetailEdit.vue'),
    ModalShowClaim: () => import('@/components/in-order/ModalShowClaim.vue'),
    ModalViewsClaim: () => import('@/components/in-order/ModalViewsClaim.vue')
  },
  props: {
    isAdd: {
      default: false,
      type: Boolean
    }
  },
  data: () => ({
    edite: false,
    newRecord: {
      status: 1,
      details: [],
      remisions: []
    },
    form: [],
    date: moment().format('YYYY-MM-DD'),
    isModalAdd: true,
    shipments_update_permission: true,
    shipments_store_permission: true,
    claim_update_permission: true,
    customer: true,
    detail: {},
    remision: {},
    index: 0,
    IsCustomer: '',
    reset: false,
    currentPage: 1,
    selected: [],
    enabledSave: true,
    isInvalid: true,
    columns: [
      'category',
      'scope'
    ],
    columnsClaims: [
      'date',
      'question',
      'answer',
      'project_id',
      'customer_id'
    ],
    columnsRemisions: [
      '',
      'description',
      'date'
    ],
    currency: [
      {
        name: 'USD',
        id: 1
      },
      {
        name: 'MXN',
        id: 2
      }
    ]
  }),
  validations: {
    newRecord: {
      remission_number: {
        required
      },
      addressee: {
        required
      },
      shipped_date: {
        required
      }
    }
  },
  shipments_remaining: {},
  beforeRouteLeave (to, from, next) {
    this.cleanShipmentsDetails()
    next()
  },
  async created () {
    this.isInvalid = false
    this.loadInOrderDetailsWithFabricated({ id: this.shipment.project_id, idshipment: this.shipment.id })
    this.initShipment(this.newRecord)
    this.$route.params.idshipment && await this.getShipment()
    !this.$route.params.idshipment && await this.loadInOrderDetailsWithFabricated({ id: this.$route.params.id })
    this.$route.params.idshipment && await this.loadInOrderDetailsWithShipment({ id: this.$route.params.id, idshipment: this.$route.params.idshipment })
    this.newRecord.shipped_date = moment().format('YYYY-MM-DD')
    this.$route.params.idshipment && await this.getClaims(this.$route.params.idshipment)
    this.checkPermissionView()
  },
  methods: {
    ...mapActions([
      'setModalShipmentClaimVisible',
      'setModalShipmentDetailVisible',
      'setModalShipmentDetailEditVisible',
      'initShipment',
      'deleteShipmentDetail',
      'addShipment',
      'editShipment',
      'loadShipment',
      'updateShipmentDetails',
      'loadInOrderDetailsWithFabricated',
      'loadInOrderDetailsWithShipment',
      'loadClaims',
      'setModalRemisionVisible',
      'cleanShipmentsDetails',
      'deleteRemision',
      'setModalShowClaimVisible',
      'setModalViewsClaimVisible',
      'loadAllDetailsUsed'
    ]),
    addProduct (details) {
      this.loadAllDetailsUsed(details)
      if (this.isModalShipmentDetailVisible) {
        this.setModalShipmentDetailVisible(false)
      } else {
        this.setModalShipmentDetailVisible(true)
      }
    },
    addRemision () {
      this.isModalAdd = true
      this.remision = {
        date: moment().format('YYYY-MM-DD')
      }

      this.setModalRemisionVisible(true)
    },
    editRemision (payload) {
      this.isModalAdd = false
      this.remision = { ...payload, type: payload.remision }

      this.setModalRemisionVisible(true)
    },
    seeRemision (attachment) {
      this.$viewer.show({
        urlFile: attachment.file_url,
        mime: attachment.mime_type,
        name: attachment.filename,
        color: '#FFF'
      })
    },
    checkPermissionView () {
      this.shipments_update_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'shipments.update') > -1
      this.shipments_store_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'shipments.store') > -1
      this.claims_update_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'claims.update') > -1
      this.customer = this.$auth.user().view_roles.findIndex(e => e === 'Customer') > -1
    },
    colorStatus (code) {
      return this.status.find(e => e.value === code)['color']
    },
    getTitle () {
      return this.isAdd ? this.$t('shipments.add') : this.$t('shipments.view')
    },
    setShipped (data) {
      let idx = this.form.findIndex(e => parseInt(e.scope_id) === parseInt(data.scope_id))
      if (data.val > 0 && data.val <= parseInt(data.limit)) {
        parseInt(idx) < 0 ? this.form.push(data) : (this.form[idx].val = data.val)
        this.isInvalid = false
      } else if (data.scope_id === this.form[idx].scope_id) {
        this.form.splice(idx, 1)
        this.isInvalid = true
      }
    },
    async getClaims (shipmentId) {
      await this.loadClaims({ filterBy: `shipment_id=${shipmentId}` })
    },
    editDetail (data, indextr) {
      data.forEach((item, index) => {
        if (index === indextr) {
          item.edit = !item.edit
        } else {
          item.edit = false
        }
        item.quantity = item.old_quantity
      })
      this.loadInOrderDetailsWithFabricated({ id: this.shipment.project_id, idshipment: this.shipment.id })
    },
    async updateShipmentOneDetail (data, indextr) {
      await this.updateShipmentDetails({ id: this.$route.params.id, shipment_id: this.$route.params.idshipment, detail: data[indextr], fabricated_date: this.date })
      this.$route.params.idshipment && await this.loadInOrderDetailsWithShipment({ id: this.$route.params.id, idshipment: this.$route.params.idshipment })
    },
    salveDetail (data, indextr) {
      if (data[indextr].quantity < 0) {
        this.$vm.dialog({ color: 'danger', title: this.$t('errors.info'), text: this.$t('strings.invalid_value') })
      } else {
        this.inOrderDetailsWithFabricated.forEach((item) => {
          const matchingData = data.find((d) => d.scope === item.scope)
          if (matchingData) {
            item.shipment_detail.forEach((detail) => {
              if (detail.id === data[indextr].id) {
                if ((item.shipment_remaining + (detail.quantity - data[indextr].quantity)) < 0) {
                  this.$vm.dialog({ color: 'danger', title: this.$t('errors.info'), text: this.$t('strings.limit_exceeded') })
                } else {
                  this.updateShipmentOneDetail(data, indextr)
                }
              }
            })
          }
        })
      }
    },
    addShipmentDetail () {
      this.isModalAdd = true
      this.setModalShipmentClaimVisible(true)
      this.detail = {}
    },
    showShipmentClaim (detail, index) {
      this.detail = { ...detail }
      this.index = index
      if (this.claims_update_permission && !this.customer) {
        this.IsCustomer = false
      } else if (this.customer) {
        this.IsCustomer = true
      }
      this.setModalShowClaimVisible(true)
    },
    claimSeen (detail, index) {
      this.setModalViewsClaimVisible(true)
      this.detail = { ...detail }
      this.index = index
    },
    editShipmentClaim (detail, index) {
      this.setModalShipmentClaimVisible(true)
      this.detail = { ...detail }
      this.index = index
      this.IsCustomer = false
    },
    async saveRecord () {
      this.enabledSave = false
      this.$vm.loading({
        background: 'primary',
        color: '#fff',
        container: '#saveRecord',
        scale: 0.45
      })
      if (!this.$route.params.idshipment) {
        await this.addShipment({ shipment: this.newRecord, idProject: this.$route.params.id, form: this.form, remisions: this.shipment.remisions })
      } else if (this.$route.params.idshipment) {
        await this.editShipment(this.newRecord)
      }
      this.form = []
      this.$vm.loading.close('#saveRecord > .con-vm-loading')
      this.$router.push(`/in-orders/${this.$route.params.id}/shipments`)
      this.enabledSave = true
      this.reset = true
    },
    doReset () {
      this.reset = false
    },
    async deleteShipmentDetailConfirm (detail, index) {
      let t = this
      this.auxDeleteShipmentDetail = () => {
        t.deleteShipmentDetail({ detail, index }).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.shipment'), attribute: detail.id ? detail.id : index }),
        accept: this.auxDeleteShipmentDetail
      })
    },
    async deleteRemisionConfirm (remision) {
      let t = this
      this.auxDeleteRemision = () => {
        t.deleteRemision(remision).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.remision'), attribute: this.$t(remision.id) }),
        accept: this.auxDeleteRemision
      })
    },
    async getShipment (page) {
      this.loadShipment(this.$route.params)
    },
    cancel () {
      this.$router.push({ name: 'shipments' })
    },
    openViewer (payload) {
      this.$viewer.show({
        urlFile: payload.file_url,
        mime: payload.mime_type,
        name: payload.filename,
        color: '#FFF'
      })
    }
  },
  computed: {
    ...mapGetters([
      'shipment',
      'claims',
      'pagination',
      'inOrderDetailsWithShipment',
      'isModalShipmentDetailVisible',
      'inOrderDetailsWithFabricated',
      'allDetails'
    ]),
    detailsLength () {
      return this.newRecord.details.length
    },
    enabledEdit () {
      return this.newRecord.id
    },
    remisions () {
      if (this.customer) {
        return this.newRecord.attachments.filter(attachment => attachment.remision === 2)
      } else {
        return this.newRecord.attachments
      }
    },
    details () {
      if (this.$route.params.idshipment) {
        return this.inOrderDetailsWithShipment
      } else {
        return this.inOrderDetailsWithFabricated
      }
    }
  },
  watch: {
    shipment (shipment) {
      this.newRecord = parseVuexObject(shipment)
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.form {
  padding: 20px 10px 0;
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.con-vm-tabs {
  padding: 10px;
  .vm-tabs--ul {
    box-shadow: none;
  }
  .vm-tabs--content {
    padding: 0;
  }
}
.vm-col {
  padding: 0 10px;
}
.modal_index {
  z-index: 999990 !important;
}
.vm-table--header {
  padding: 0px !important;
  span {
    width: 100%;
    .justify-content-between {
      div:last-child {
        .vm-button {
          margin: 0 3px;
          display: block;
        }
        .vm-con-dropdown {
          float: left;
        }
        .con-select {
          display: inline-block;
          input {
            height: 32px;
          }
        }
      }
    }
  }
}
.icon-btn {
  width: 30px;
  height: 30px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background: rgb(231, 231, 231);
  }
}
.btn_set {
  margin: 20px 20px;
}
</style>
